import { gql } from '@apollo/client';

export const INBOX_ITEM_FIELDS = gql`
  fragment InboxItemFields on InboxItem {
    id
    kind
    subjectType
    subjectId
    title
    body
    payload
    status
    country
    attendedBy
    attendedAt
    createdAt
    updatedAt
  }
`;

export const SUPPLIER_INBOX = gql`
  query SupplierInbox($filter: InboxFilter, $pagination: Pagination) {
    supplierInbox(filter: $filter, pagination: $pagination) {
      ...InboxItemFields
    }
    supplierInboxCount(filter: $filter)
  }
  ${INBOX_ITEM_FIELDS}
`;
